import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Raffle.module.sass";

import Card from "../../components/Card";
import Form from "../../components/Form";
import RaffleTable from "./RaffleTable";
import TemplateModal from "../NewProduct/TemplateModal";
import { UseDisclosure } from "../../hooks/use-disclosure";
import CreateProduct from "./CreateProduct";
import { GetDrRaffle, GetRaffle } from "../../Services/lib/nfttemplates";
import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import raffle from "../../i11/Raffle";
import Filters from "../../components/Filters";
import Settings from "./settings";

export const rafflePageLimit = 5;

const Raffle = () => {
	const { locale } = useUser();
	const [visible, setVisible] = useState(false);
	const navigation = [raffle[locale].published, raffle[locale].drafts];
	const {
		isOpen: createV,
		onOpen: createO,
		onClose: createC,
	} = UseDisclosure();
	const [raffleList, setRaffleList] = useState();
	const [raffleDraftList, setRaffleDraftList] = useState();

	const [pagePublish, setPagePublish] = useState(1);
	const [pageDraft, setPageDraft] = useState(1);
	const [search, setSearch] = useState("");

	const [index, setIndex] = useState(0);
	const [filter, setFilter] = useState({
		page: 1,
		limit: rafflePageLimit,
		order_direction: -1,
		order_by: "endDate",
		search: "",
	});

	const [{ isLoading }, getRaffle] = UseApi({
		service: GetRaffle,
	});
	const [{ isLoading: loading }, getDraftRaffle] = UseApi({
		service: GetDrRaffle,
	});

	const getRaffle_ = async (pagination) => {
		const fl = {
			...filter,
			...pagination,
		};
		const result = await getRaffle(fl);
		if (result) {
			setRaffleList(result);
		}
	};
	const getDraftRaffle_ = async (pagination) => {
		const fl_ = {
			...filter,
			...pagination,
		};
		const result = await getDraftRaffle(fl_);
		if (result) {
			setRaffleDraftList(result);
		}
	};
	const getInit = (sr) => {
		getRaffle_(sr);
		getDraftRaffle_(sr);
	};
	const onSubmit = (e) => {
		e.preventDefault();
		if (filter.search !== search) {
			setFilter((p) => {
				return {
					...p,
					search: search,
					page: 1,
				};
			});
		}
	};
	const restPublish = {
		page: pagePublish,
		setPage: setPagePublish,
	};
	const restDraft = {
		page: pageDraft,
		setPage: setPageDraft,
	};
	useEffect(() => {
		getRaffle_({ page: pagePublish });
	}, [pagePublish, filter]);
	useEffect(() => {
		getDraftRaffle_({ page: pageDraft });
	}, [pageDraft, filter]);
	return (
		<>
			<Card
				title={raffle[locale].raffle_name}
				classTitle={cn("title-red", styles.title)}
				classCardHead={styles.head}
				head={
					<>
						<Form
							placeholder={raffle[locale].search}
							type="text"
							name="search"
							icon="search"
							required={false}
							value={search}
							setValue={setSearch}
							onSubmit={onSubmit}
						/>

						<button
							type="button"
							onClick={() => createO()}
							className="button-small"
						>
							{raffle[locale].create_raffle}
						</button>
					</>
				}
			>
				<div className={styles.control}>
					<div className={styles.nav}>
						{navigation.map((x, i) => (
							<button
								key={"__button__" + i}
								className={cn(styles.link, {
									[styles.active]: i === index,
								})}
								onClick={() => setIndex(i)}
							>
								{x}
							</button>
						))}
					</div>
					<Filters
						visible={visible}
						setVisible={setVisible}
						className={styles.filters}
						title={raffle[locale].filter}
					>
						<Settings
							setVisible={setVisible}
							filter={filter}
							setFilter={setFilter}
							applyFunc={getInit}
						/>
					</Filters>
				</div>
				{index === 0 && (
					<RaffleTable
						loading={isLoading}
						items={raffleList}
						getData={getInit}
						rest={restPublish}
					/>
				)}
				{index === 1 && (
					<RaffleTable
						loading={loading}
						items={raffleDraftList}
						getData={getInit}
						rest={restDraft}
					/>
				)}
			</Card>

			<TemplateModal visible={createV} onClose={() => createC()}>
				{createV && <CreateProduct close={createC} getData={getInit} />}
			</TemplateModal>
		</>
	);
};

export default Raffle;
